import { speed } from "jquery";

$(function() {
	// $('#kvSlide').fadeIn(0);
	$('#kvSlide').addClass('is-show');
});

$(document).ready(function() {
	var slider = ".slider";
	var thumb = ".thumb";
	var thumbitem = thumb + " .thumbnail-item";

	// サムネイル画像アイテムに data-index でindex番号を付与
	$(thumbitem).each(function() {
			var index = $(thumbitem).index(this);
			$(this).attr("data-index", index);
	});

	// スライダー初期化後、カレントのサムネイル画像にクラス「thumbnail-current」を付ける
	$(slider).on('init', function(slick) {
			var index = $(".slide-item.slick-slide.slick-current").attr("data-slick-index");
			$(thumbitem + '[data-index="' + index + '"]').addClass("thumbnail-current");
	});

	//サムネイル画像アイテムをクリックしたときにスライダー切り替え
	$(thumbitem).on('click', function() {
			var index = $(this).attr("data-index");
			$(slider).slick("slickGoTo", index, false);
	});

	//サムネイルフォーカス
	$(slider).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			$(thumbitem).each(function() {
					$(this).removeClass("thumbnail-current");
			});
			$(thumbitem + '[data-index="' + nextSlide + '"]').addClass("thumbnail-current");
	});

	//スライダー設定
	$(slider).slick({
			// autoplay: true,
			arrows: false,
			fade: true,
			infinite: true,
			speed: 700
	});
});

